import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";
import FormatCurrency from "shared/components/currency/FormatCurrency";
import { FormattedMessage } from "react-intl";
import { ResponsiveImage } from "shared/components/elements/ResponsiveImage";

import { toggleConfirmationDialog } from "shared/components/dialogs/ConfirmationDialogContainer";
import { roomBookController } from "shared/actions/roomBookController";

import { withRouter } from "../../../helpers/withRouter";

class LineItemPicker extends React.Component {
  handleSelection = lineItem => {
    if (lineItem.isOptional) {
      return this.handleOptionalLineItem(lineItem);
    }
    return null;
  };

  handleOptionalLineItem = lineItem => {
    const { confirmationDialog } = this.props;

    const content = (
      <Grid>
        <Grid.Column width={7}>
          <ResponsiveImage src={lineItem.thumbUrl} height="200px" />
        </Grid.Column>
        <Grid.Column width={9}>
          <p>
            <strong>
              <FormattedMessage id="buyerPortal.roomBook.optionalLineItem.attributes.totalBase" />
              :
            </strong>
            <br />
            {!lineItem.isPriceOnRequest && (
              <FormatCurrency amount={lineItem.totalMin} />
            )}
            {lineItem.isPriceOnRequest && <span>Preis auf Anfrage</span>}
          </p>
          <p className="mute">
            <strong>
              <FormattedMessage id="meta.title.hint" />:
            </strong>
            <br />
            <FormattedMessage id="buyerPortal.roomBook.optionalLineItem.hints.extraCosts" />
          </p>
        </Grid.Column>
      </Grid>
    );

    return new Promise((resolve, reject) => {
      if (lineItem.isBackendActivated) {
        resolve(lineItem);
      } else {
        confirmationDialog({
          title: (
            <FormattedMessage
              id="buyerPortal.roomBook.optionalLineItem.actions.add.title"
              values={{ ...lineItem }}
            />
          ),
          content,
          buttons: [
            {
              id: "ok",
              label: "meta.actions.add",
              color: "primary",
              onClick: cb => {
                cb();
                resolve(lineItem);
              }
            },
            {
              id: "cancel",
              label: "meta.actions.cancel",
              color: "secondary",
              basic: true,
              onClick: cb => {
                cb();
                reject();
              }
            }
          ]
        });
      }
    });
  };

  render() {
    const { children } = this.props;
    return children({
      select: this.handleSelection
    });
  }
}

LineItemPicker.propTypes = {
  children: PropTypes.func.isRequired
};

const mapStateToProps = null;

const mapDispatchToProps = (dispatch, props) => {
  const { id } = props.params;
  const ctrl = roomBookController(dispatch, id);
  return {
    deselectProducts: subLineItemIds => {
      return ctrl.deselectProducts(subLineItemIds);
    },
    selectProducts: selections => {
      return ctrl.selectProducts(selections);
    },
    confirmationDialog: toggleConfirmationDialog(dispatch)
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LineItemPicker)
);
